import { MapViewerService } from '@3ddv/ngx-dvm-internal';
import { InjectionToken } from '@angular/core';

export const BG_MAP_VIEWER_TOKEN = new InjectionToken<MapViewerService>(
  'BG_MAP_VIEWER_TOKEN'
);
